import { module } from 'stereomodularjs';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.container = this.el;
        this.sections = this.$('item');
        this.sectionsCount = this.sections.length;
        this.endValue = `+=${this.sectionsCount * 100}%`;

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.container,
                start: 'top, top',
                end: this.endValue,
                scrub: 1,
                pin: this.container,
                // markers: true, // Debug
            },
            ease: "none",
        });

        this.sections.forEach((section, i) => {
            if (i === 0) return; // Skip the first element
            this.tl.fromTo(
                section,
                {
                    transform: 'translate3d(0,100vh,0) scale3d(1.25,1.25,1) rotate(0.01deg)',
                },
                {
                    transform: 'translate3d(0,0,0) scale3d(1.0001,1.0001,1) rotate(0.01deg)',
                }
            );
        });

        window.addEventListener('resize', () => {
            ScrollTrigger.refresh(true)
        });

        setTimeout(() => {
            ScrollTrigger.refresh(true)
        }, 1000);
    }

    destroy() {
        super.destroy()
        this.allScrollTrigger = ScrollTrigger.getAll()
        for (let i = 0; i < this.allScrollTrigger.length; i++) {
            this.allScrollTrigger[i].kill(true)
        }
        gsap.globalTimeline.clear()
    }
}